import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { Collapse } from '@bringg/react-components';

import { KeyValueItem } from './hooks/use-key-value-definition-table-state';
import KeyValueTable from './key-value-table';
import { useKeyValueDefinitionTableState } from './hooks/use-key-value-definition-table-state';

const { Panel } = Collapse;

interface KeyValueCollapsibleTableProps {
	headerLabel: string;
	panelKey: string;
	value?: Record<string, string>;
	onChange?: (value: Record<string, string>) => void;
}

export const KeyValueCollapsibleTable = ({
	value = {},
	onChange,
	headerLabel,
	panelKey
}: KeyValueCollapsibleTableProps) => {
	const { t } = useTranslation();
	const headersDefinition = useMemo(
		() =>
			Object.keys(value).reduce((acc, key) => {
				acc.push({ key, value: value[key] });

				return acc;
			}, [] as KeyValueItem[]),
		// don't add value to the dependency array it will cause infinite onChange callback invocation
		[]
	);

	const headersDefinitionState = useKeyValueDefinitionTableState({
		allowEmpty: true,
		keyValueDefinition: headersDefinition,
		onChange: (headers: KeyValueItem[]) => {
			const keyValueHeaders = headers.reduce((acc: Record<string, string>, cur: KeyValueItem) => {
				acc[cur.key] = cur.value as string;

				return acc;
			}, {});

			onChange?.(keyValueHeaders);
		},
		translations: {
			errors: {
				emptyRowMessage: t('WEBHOOK_AUTHENTICATION_METHOD.MODAL.ERRORS.NO_EMPTY_LIST'),
				noSameValue: t('WEBHOOK_AUTHENTICATION_METHOD.MODAL.ERRORS.NO_SAME_VALUE'),
				keyAndValueNotEmpty: t('WEBHOOK_AUTHENTICATION_METHOD.MODAL.ERRORS.VALUE_AND_NAME_NOT_EMPTY')
			}
		}
	});

	return (
		<Collapse removePadding>
			<Panel header={headerLabel} key={panelKey}>
				<KeyValueTable
					// TODO: Flatten state object to individual props (breaks React.memo, harder to test, poor DX). Use {...stateProps} spread instead.
					state={headersDefinitionState}
					headers={{
						keyLabel: t('WEBHOOK_AUTHENTICATION_METHOD.MODAL.KEY'),
						valueLabel: t('WEBHOOK_AUTHENTICATION_METHOD.MODAL.VALUE')
					}}
				/>
			</Panel>
		</Collapse>
	);
};
